<div class="no-data" [style.height]="height">
    <span *ngIf="icon" class="icon no-data-icon" [svgIcon]="icon"></span>
    <h3 *ngIf="title" class="no-data-title">{{ title }}</h3>
    <p *ngIf="description" class="no-data-desc">{{ description }}</p>
</div>
